import { createDataModuleActions } from '@perpay-web/data-module/createDataModuleActions';

const dataModuleActions = createDataModuleActions('FETCH_CARD_ACCOUNT');
export const fetchCardAccount = dataModuleActions.dataRequest;
export const replaceCardAccount = dataModuleActions.dataSuccess;
export const setCardAccountError = dataModuleActions.dataError;
export const resetCardAccount = dataModuleActions.dataReset;
